import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable, of, tap } from 'rxjs';
import { SessionService } from './session.service';
import { VerticalComponent } from '@/app/layouts/vertical/vertical.component';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class UserInfoResolver implements Resolve<VerticalComponent> {

  constructor(private userService: UserService, private sessionService: SessionService) {
  }

resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

  return this.userService.getUserProfileInfo().pipe(
    tap((userData) => {
      if (userData) {
        const currentAuth = this.sessionService.getAuthInfo();
        // currentAuth can be null if localStorage was cleared in another
        // tab between the route activation and the profile response
        // arriving. Without this guard, the property accesses crash the
        // route navigation instead of cleanly redirecting to login.
        if (!currentAuth || !currentAuth.access_token) {
          this.sessionService.logout();
          return;
        }
        this.sessionService.storeAuthData(
          currentAuth.access_token,
          currentAuth.refresh_token,
          currentAuth.token_type,
          userData
        );
      } else {
        console.warn('No user data received from profile API');
      }
    }),
    catchError((error) => {
      if (error.status === 401 || error.status === 403) {
        console.log('Authentication error - token might be invalid');
        this.sessionService.logout();
      }
      return of(null);
    })
  );
}

}
